import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';
import { Input } from '../input';
import { theme } from '../theme';
import { InboxMessageDisplay } from './components';
import { FormMaxWidth } from '../../layout/styled';

export const StyledInboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1rem;

  border: 1px solid ${theme.colors.primaryK2};

  ${mediaQuery('md')} {
    flex-direction: row;
  }

  // Animations

  .inbox-message-display-enter {
    opacity: 0;
  }

  .inbox-message-display-enter-active {
    opacity: 1;
    transition: opacity 200ms ease-in;
  }

  .inbox-message-display-exit {
    opacity: 1;
  }

  .inbox-message-display-exit-active {
    opacity: 0;
    transition: opacity 200ms ease-out;
  }

  // On desktop, inbox message display rendering is not animated.

  ${mediaQuery('md')} {
    .inbox-message-display-enter {
      opacity: 0;
    }

    .inbox-message-display-enter-active {
      opacity: 1;
      transition: opacity 0ms ease-in;
    }

    .inbox-message-display-exit {
      opacity: 1;
    }

    .inbox-message-display-exit-active {
      opacity: 0;
      transition: opacity 0ms ease-out;
    }
  }
`;

export const StyledMessageCardsContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  ${mediaQuery('md')} {
    width: ${FormMaxWidth};
    border-right: 1px solid ${theme.colors.primaryK2};
    height: 35rem;
  }
`;

export const StyledSearchInputContainer = styled.div`
  height: 5.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const StyledSearchInput = styled(Input)`
  width: 85%;

  ${mediaQuery('md')} {
    width: 20.375rem;
  }
`;

export const StyledInboxMessageDisplay = styled(InboxMessageDisplay)`
  flex: 1;

  ${mediaQuery('md')} {
    height: 35rem;
  }
`;

export const StyledNoMessagesContainer = styled.div`
  color: ${theme.colors.primaryK4};
  font-size: var(--main-font-size);
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledNoSelectedMessageContainer = styled.div`
  display: none;

  ${mediaQuery('md')} {
    display: initial;

    color: ${theme.colors.primaryK4};
    font-size: var(--main-font-size);
    text-align: center;

    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
  }
`;
